import React from 'react';
import TagRender from '../common/TagRender';
export const getDisplayColumns = (divisionMap, useRedesign, labelMap, labelToMap) => {
  const baseColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      width: 200,
    },
    {
      title: 'Office Address',
      dataIndex: 'officeAddress',
      width: 150,
    },
    {
      title: 'Office Number',
      dataIndex: 'officeNumber',
      width: 100,
    },
    {
      title: 'Office Email',
      dataIndex: 'officeEmail',
      width: 125,
    },
    {
      title: 'Billing Email',
      dataIndex: 'billingEmail',
      width: 125,
    },
    {
      title: 'Divisions',
      dataIndex: 'divisionIds',
      width: 125,
      render: (divisionIds) => (
        <TagRender
          tagMap={divisionMap}
          tagIds={divisionIds}
          useRedesign={useRedesign}
        />
      ),
    },
  ];

  if (Object.keys(labelMap).length > 0) {
    baseColumns.push({
      title: 'Labels',
      dataIndex: 'labels',
      width: 125,
      render: (_, record) => {
        const {
          [record.id]: ourLabels = [],
        } = labelToMap;
        return (
        <TagRender
          tagMap={labelMap}
          tagIds={ourLabels}
          useRedesign={useRedesign}
          labelKey="title"
        />
        );
      },
    });
  }

  return baseColumns;
};
